/**
 * The reference event.
 *
 * Every other BEO in the game is generated (see `src/sim/beoGen.js`). This one
 * is hand-written and never changes, because it is the benchmark: the walked
 * playthrough sets exactly this room, every time, and the number it reports is
 * what the effort model in `beoTemplates.js` is calibrated against.
 *
 * If you change the cart's capacity, the length of the property or the speed of
 * the controller, run `npm run playthrough`, and put the new minutes into
 * EFFORT. Do not change this event to make the number look better.
 */
export const REFERENCE_BEO = {
  id: 'beo-reference',
  code: 'BEO 1101',
  title: 'Ashford / Vance Reception',
  client: 'Ashford & Vance',
  owner: 'banquets',
  type: 'reception',
  room: 'ballroom',
  postedAt: '12:00',
  setupBy: '19:00',
  doors: '19:30',
  covers: 48,
  setup: {
    tableType: 'round',
    tableCount: 6,
    chairsPerTable: 8,
    linen: 'ivory',
    // Three across, two deep, in from the north-west corner of the grid.
    layout: { col: 1, row: 1, cols: 3, rows: 2 },
    staging: ['Dance floor to remain clear', 'Aisle on the ballroom doors side'],
  },
  award: { banquets: 22 },
  note: 'Mother of the bride will count the chairs. She will count them twice.',
  /** The benchmark is deliberately not short of anything. */
  shortfalls: [],
};

/**
 * The first room anybody is given.
 *
 * Handed out by Serg on a new starter's first afternoon, and it is the only
 * thing on the board that day, because a first board with five cards on it is
 * a lesson in reading a board and not in any of the things underneath it.
 *
 * Two rounds of four, and short of nothing. It is the guided first day's room
 * (`sim/tutorial.js`), and that day teaches exactly the board, picking a thing
 * up, setting it on its spot and filing; asking somebody for what a room is
 * short of is day two's lesson, on a generated board. Four chairs a round so
 * the chairs are one armful from storage (it was eight, and short of linen,
 * which asked a first-day player to negotiate through a menu nobody had shown
 * them; D: "a player who has never seen the game must be able to finish day
 * one without guessing once").
 *
 * The award is the benchmark room's rather than what the generator would pay a
 * two-table room. The section judges a new starter on the first room they set,
 * and a clean one is what brings Lil D over at the end of the night — after a
 * whole shift sober, which is the order that beat is written for.
 */
export const FIRST_BEO = {
  id: 'beo-first',
  code: 'BEO 1100',
  title: 'Castellan Book Club',
  client: 'Castellan Book Club',
  owner: 'banquets',
  type: 'luncheon',
  room: 'ballroom',
  postedAt: '13:00',
  setupBy: '17:30',
  doors: '18:00',
  covers: 8,
  setup: {
    tableType: 'round',
    tableCount: 2,
    chairsPerTable: 4,
    linen: 'ivory',
    layout: { col: 1, row: 1, cols: 2, rows: 1 },
    staging: ['Two rounds by the north wall'],
  },
  award: { banquets: 22 },
  note: 'Eight of them, and they will want to sit in the same seats as last month.',
  shortfalls: [],
};

export default REFERENCE_BEO;
